module.exports = __webpack_public_path__ + "img/factoryPoint.4a6bedd5.png";